/**
 * Have a different version to support legacy layout exports
 */

export function isLayoutV2(layout) {
  return layout.version === 2;
}
export function isLayoutV1(layout) {
  return Array.isArray(layout);
}

/**
 * Interface for accessing layouts from wherever they are stored.
 */
//# sourceMappingURL=LayoutStorage.js.map